import * as Monaco from 'monaco-editor/esm/vs/editor/editor.api';

import { LanguageId } from 'src/containers/MonacoEditor/constants/languageId';

export const SRS_EDITOR_OPTIONS: Monaco.editor.IStandaloneEditorConstructionOptions =
  {
    automaticLayout: false,
    codeLens: false,
    contextmenu: false,
    fontSize: 14,
    hideCursorInOverviewRuler: true,
    hover: {
      delay: 1000,
    },
    language: LanguageId.SRS,
    links: false,
    minimap: {
      enabled: false,
    },
    occurrencesHighlight: 'off',
    parameterHints: { enabled: false },
    renderLineHighlight: 'none',
    scrollBeyondLastLine: true,
    selectOnLineNumbers: true,
    snippetSuggestions: 'none',
    quickSuggestions: true,
    wordBasedSuggestions: 'off',
  };

export const LANGUAGE_CONFIGURATION: Monaco.languages.LanguageConfiguration = {
  brackets: [
    ['(', ')'],
    ['[', ']'],
    ['{', '}'],
  ],
  autoClosingPairs: [
    {
      open: '(',
      close: ')',
    },
    {
      open: '[',
      close: ']',
    },
    {
      open: '{',
      close: '}',
    },
    {
      open: "'",
      close: "'",
    },
    {
      open: '"',
      close: '"',
    },
    {
      open: '<',
      close: '>',
    },
  ],
  indentationRules: {
    increaseIndentPattern: /{$/m,
    decreaseIndentPattern: /}$/m,
  },
  wordPattern: /[^;,{}() <>/]/g,
  comments: {
    lineComment: '#',
  },
};
